import { liveViewLink, managementLink, mapLink, recordLink } from '../../../../router/routerLink';

import { ListItemIcon } from '@mui/material';
import liveActive from '../../../../icons/liveViewActive.svg';
import liveDefault from '../../../../icons/liveViewDefault.svg';
import liveHover from '../../../../icons/liveViewHover.svg';
import manageActive from '../../../../icons/manageActive.svg';
import manageDefault from '../../../../icons/manageDefault.svg';
import manageHover from '../../../../icons/manageHover.svg';
import mapActive from '../../../../icons/mapActive.svg';
import mapDefault from '../../../../icons/mapDefault.svg';
import mapHover from '../../../../icons/mapHover.svg';
import recordActive from '../../../../icons/recordActive.svg';
import recordDefault from '../../../../icons/recordDefault.svg';
import recordHover from '../../../../icons/recordHover.svg';

export const generalmenuItems = [
  {
    heading: "general",
    items: [
      {
        name: 'Live View',
        icon: ListItemIcon,
        image: liveDefault,
        hoverImage: liveHover,
        selectedImage: liveActive,
        alt: "liveview",
        link: liveViewLink
      },
      {
        name: 'Map',
        icon: ListItemIcon,
        image: mapDefault,
        hoverImage: mapHover,
        selectedImage: mapActive,
        alt: "map",
        link: mapLink
      },
      {
        name: 'Recorded Videos',
        icon: ListItemIcon,
        image: recordDefault,
        hoverImage: recordHover,
        selectedImage: recordActive,
        alt: "record",
        link: recordLink
      }
    ]
  },

];

export const managementMenuItems = [
  {
    heading: "management",
    items: [
      {
        name: 'Management',
        icon: ListItemIcon,
        image: manageDefault,
        hoverImage: manageHover,
        selectedImage: manageActive,
        alt: "management",
        link: managementLink
      },

    ]
  },

];

